import { Routes } from '@angular/router';

/**
 * ¿Existe esta ruta en la configuración del router? (§4.2 del contrato)
 *
 * El backend puede sembrar en el catálogo un módulo cuya pantalla todavía no se
 * desplegó. Sin este chequeo, el ítem se pinta, el usuario hace click y cae en un
 * 404 — hoy mismo pasaría con `/app/legal-documents`, que vive en un PR sin mergear
 * y encima llega con badge «nuevo».
 *
 * LÍMITE CONOCIDO: las rutas del portal son lazy, así que `router.config` sólo
 * tiene los segmentos estáticos hasta el primer `loadChildren`. Al cruzar esa
 * frontera se acepta el resto, porque verificarlo exigiría descargar todos los
 * chunks del portal en el arranque. Detecta un MÓDULO ausente (el caso que motiva
 * la regla); no detecta un SUBMÓDULO ausente dentro de un feature ya desplegado
 * — por ejemplo `/app/back-office/fuel-types`. Ahí el daño queda acotado a la
 * pantalla de 404 del `{ path: '**' }`.
 */
export function routeExists(url: string, routes: Routes): boolean {
  const segments = url.split('?')[0].split('/').filter(Boolean);
  return matches(segments, routes);
}

function matches(segments: string[], routes: Routes): boolean {
  for (const route of routes) {
    if (route.path === undefined) continue;
    // El comodín matchea cualquier cosa: aceptarlo convertiría este chequeo en un
    // `return true` disfrazado, y es justo la ruta que lleva al 404.
    if (route.path === '**') continue;

    const routeSegments = route.path.split('/').filter(Boolean);
    if (routeSegments.length > segments.length) continue;

    const consumed = routeSegments.every(
      (segment, i) => segment.startsWith(':') || segment === segments[i],
    );
    if (!consumed) continue;

    const rest = segments.slice(routeSegments.length);
    if (rest.length === 0) return true;
    if (route.loadChildren) return true;
    if (route.children && matches(rest, route.children)) return true;
  }

  return false;
}
